import React from 'react';
import { Zap, Package, AlertTriangle, Ban, Clock } from 'lucide-react';

const LotFilters = ({ activeFilter, setActiveFilter, filteredLots }) => {
  // Calcular totales
  const totalLots = filteredLots.length;
  const totalBultos = filteredLots.reduce((sum, lot) => sum + (Number(lot.quantity) || 0), 0);

  return (
    <div className="space-y-2">
      <div className="flex gap-2 mb-4 px-1 overflow-x-auto pb-2">
        <button
          onClick={() => setActiveFilter('all')}
          className={`px-3 py-1.5 rounded-full text-sm flex items-center gap-1.5 transition-colors whitespace-nowrap
            ${activeFilter === 'all'
              ? 'bg-blue-100 dark:bg-blue-900/50 text-blue-700 dark:text-blue-400' 
              : 'bg-gray-100 dark:bg-gray-800 text-gray-500 dark:text-gray-400'}`}
        >
          <Package className="w-4 h-4" />
          Todos
        </button>
        
        <button
          onClick={() => setActiveFilter('available')}
          className={`px-3 py-1.5 rounded-full text-sm flex items-center gap-1.5 transition-colors whitespace-nowrap
            ${activeFilter === 'available'
              ? 'bg-green-100 dark:bg-green-900/50 text-green-700 dark:text-green-400' 
              : 'bg-gray-100 dark:bg-gray-800 text-gray-500 dark:text-gray-400'}`}
        >
          <Package className="w-4 h-4" />
          Disponible
        </button>

        <button
          onClick={() => setActiveFilter('lightning')}
          className={`px-3 py-1.5 rounded-full text-sm flex items-center gap-1.5 transition-colors whitespace-nowrap
            ${activeFilter === 'lightning'
              ? 'bg-amber-100 dark:bg-amber-900/50 text-amber-700 dark:text-amber-400' 
              : 'bg-gray-100 dark:bg-gray-800 text-gray-500 dark:text-gray-400'}`}
        >
          <Zap className="w-4 h-4" />
          Relámpago
        </button>
        
        <button
          onClick={() => setActiveFilter('nostock')}
          className={`px-3 py-1.5 rounded-full text-sm flex items-center gap-1.5 transition-colors whitespace-nowrap
            ${activeFilter === 'nostock'
              ? 'bg-orange-100 dark:bg-orange-900/50 text-orange-700 dark:text-orange-400' 
              : 'bg-gray-100 dark:bg-gray-800 text-gray-500 dark:text-gray-400'}`}
        >
          <Ban className="w-4 h-4" />
          Sin stock
        </button>
        
        <button
          onClick={() => setActiveFilter('review')}
          className={`px-3 py-1.5 rounded-full text-sm flex items-center gap-1.5 transition-colors whitespace-nowrap
            ${activeFilter === 'review'
              ? 'bg-red-100 dark:bg-red-900/50 text-red-700 dark:text-red-400' 
              : 'bg-gray-100 dark:bg-gray-800 text-gray-500 dark:text-gray-400'}`}
        >
          <AlertTriangle className="w-4 h-4" />
          Revisar
        </button>
        
        {/* Pendiente deshabilitado por ahora */}
        <button
          disabled
          className="px-3 py-1.5 rounded-full text-sm flex items-center gap-1.5 transition-colors whitespace-nowrap bg-gray-100 dark:bg-gray-800 text-gray-400 dark:text-gray-500 opacity-50 cursor-not-allowed"
        >
          <Clock className="w-4 h-4" />
          Pendiente
        </button>
      </div>

      {/* Contador de totales */}
      <div className="px-1 text-sm text-gray-500 dark:text-gray-400 flex gap-3">
        <span>{totalLots} lotes</span>
        <span>•</span>
        <span>{totalBultos.toLocaleString()} bultos</span>
      </div>
    </div>
  );
};

export default LotFilters; 